export const environment = {
  apiUrl: 'https://vivavolei.api.hmg.mutuaassessoria.com.br/api'
};
